import { render, staticRenderFns } from "./LayoutContentUserInfor.vue?vue&type=template&id=0620fb52&scoped=true"
import script from "./LayoutContentUserInfor.vue?vue&type=script&lang=js"
export * from "./LayoutContentUserInfor.vue?vue&type=script&lang=js"
import style0 from "./LayoutContentUserInfor.vue?vue&type=style&index=0&id=0620fb52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0620fb52",
  null
  
)

export default component.exports